<div class="rt-container">

  <!-- Sub-tab navigation -->
  <mat-tab-group [selectedIndex]="selectedSubTabIndex" (selectedIndexChange)="onSubTabChange($event)"
    animationDuration="150ms" class="rt-sub-tabs">

    <!-- User VMs -->
    <mat-tab *ngIf="hasVmResource">
      <ng-template mat-tab-label>
        <mat-icon class="rt-tab-icon">computer</mat-icon>
        User VMs
      </ng-template>
      <app-user-vms-sub-tab [classId]="classId" [classEntity]="classEntity" [canDestroyResources]="canDestroyResources"
        [userVms]="userVms" [isLoading]="isLoadingUserVms" [loadError]="userVmsError" [vmPowerStates]="vmPowerStates"
        (refreshRequested)="loadUserVms()" [exportService]="exportService">
      </app-user-vms-sub-tab>
    </mat-tab>

    <!-- Templates -->
    <mat-tab *ngIf="hasVmResource">
      <ng-template mat-tab-label>
        <mat-icon class="rt-tab-icon">view_in_ar</mat-icon>
        Templates
      </ng-template>
      <app-templates-sub-tab [classId]="classId" [classEntity]="classEntity" [canDestroyResources]="canDestroyResources"
        [templateVms]="templateVms" [isLoading]="isLoadingTemplateVms" [loadError]="templateVmsError"
        [vmPowerStates]="vmPowerStates" (refreshRequested)="loadUserVms(); templateVmChanged.emit()" [exportService]="exportService">
      </app-templates-sub-tab>
    </mat-tab>

    <!-- User Accounts -->
    <mat-tab *ngIf="hasAccResource">
      <ng-template mat-tab-label>
        <mat-icon class="rt-tab-icon">manage_accounts</mat-icon>
        User Accounts
      </ng-template>
      <app-user-accounts-sub-tab [classId]="classId" [classEntity]="classEntity"
        [canDestroyResources]="canDestroyResources" [userAccounts]="userAccounts" [isLoading]="isLoadingUserAccounts"
        [loadError]="userAccountsError" (refreshRequested)="loadUserVms()" [exportService]="exportService">
      </app-user-accounts-sub-tab>
    </mat-tab>

  </mat-tab-group>

</div>